/*! @azure/msal-browser v4.25.1 2025-10-17 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const pageException = "PageException";
const userSwitch = "user_switch";

export { contentError, pageException, userSwitch };
//# sourceMappingURL=NativeAuthErrorCodes.mjs.map
